import React from "react";
import { Grid, TextField, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  label: {
    fontSize: "10px",
    color: theme.dispatchPanelHeaderColor,
    lineHeight: "16px",
    fontWeight: 500,
    paddingTop: 8,
    paddingBottom: 8,
    letterSpacing: "1.5px",
    paddingLeft: 20,
  },
  valueContainer: {
    display: "flex",
    direction: "column",
    alignItems: "center",
    paddingBottom: 12,
    "&>div": {
      flex: 1,
      width: "100%",
    },
    paddingLeft: 20,
    paddingRight: 20,
  },
  inputLabelRoot: {
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
  },
  inputField: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelLabelValueColor,
    height: "initial",
  },
  multilineInput: {
    padding: 12,
  },
  notchedOutline: {
    borderColor: theme.gridIconBorderColor,
  },
  root: {
    marginTop: 0,
    "& $notchedOutline": {
      borderColor: theme.gridIconBorderColor,
    },
  },
});

const Notes = (props) => {
  const {classes } = props;
  return (
    <>
      <Grid item xs={12} className={classes.label}>
        COMMENTS
      </Grid>
      <Grid item xs={12} className={classes.valueContainer}>
        <TextField
          id={"comments"}
          autoComplete="off"
          InputLabelProps={{
            classes: {
              root: classes.inputLabelRoot,
            },
          }}
          InputProps={{
            classes: {
              input: classes.inputField,
              multiline: classes.multilineInput,
              notchedOutline: classes.notchedOutline,
            },
          }}
          value={props.value}
          multiline
          rowsMax={5}
          rows={4}
          margin="normal"
          onChange={(event) => props.onChange(event.target.value)}
          variant="outlined"
          label="Add notes here"
          classes={{ root: classes.root }}
        />
      </Grid>
    </>
  );
};

export default withStyles(styles)(Notes);
